import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import FormHelperText from '@mui/material/FormHelperText';
import { Field, ErrorMessage } from 'formik';
import { RadioGroup } from 'formik-mui';
import Label from '../Label';

const contentSquareMaskIds = {
  'GDPR': 'user-in-eu',
  'CCPA/CPRA': 'user-in-ca',
}

RegulatoryScopeField.propTypes = {
  touched: PropTypes.any,
  regulatoryScope: PropTypes.any,
  errors: PropTypes.any,
  disabled: PropTypes.bool,
};

function RegulatoryScopeField(props) {
  const scopeId = props?.regulatoryScope?.id;

  return (
    <FormControl
      variant="standard"
      id={contentSquareMaskIds[scopeId]}
      component='fieldset'
      margin='normal'
      fullWidth
      error={props.touched.regulatoryScopes?.[props.regulatoryScope.id] &&
      props.errors.regulatoryScopes?.[props.regulatoryScope.id]}
    >
      <Label component='legend'>
        {props.regulatoryScope.scopeQuestion}
        {props.regulatoryScope.scopeExplanation && (
          <small>{props.regulatoryScope.scopeExplanation}</small>
        )}
      </Label>
      <Field
        component={RadioGroup}
        name={`regulatoryScopes.${props.regulatoryScope.id}`}
        row
      >
        <FormControlLabel
          value='0'
          control={<Radio color='secondary' disabled={props.disabled} size='small'/>}
          label="No"
          disabled={props.disabled}
        />
        <FormControlLabel
          value='1'
          control={<Radio color='secondary' disabled={props.disabled} size='small'/>}
          label="Yes"
          disabled={props.disabled}
        />
      </Field>
      <ErrorMessage
        name={`regulatoryScopes.${props.regulatoryScope.id}`}
        component={FormHelperText}
      />
    </FormControl>
  );
}

export default RegulatoryScopeField;
